import styled from '@emotion/styled'
import { theme } from '../mui'

const HeaderText = styled.div`
  color: ${theme.palette.common.black};
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  line-height: 158%;

  display: flex;
  align-items: center;
  letter-spacing: 0.15rem;
  text-transform: uppercase;
`

export default HeaderText
